const getRowIndex = (index: number, columns: number) => {
  if (index < columns) return index;
  return index % columns;
};

export default getRowIndex;
